'use client';

const loadingStartMsg = "Loading options";
const emptyLabel = "No options available";
const listLabel = (label) => label ? `Options for ${label}` : "Options";
export {
  emptyLabel,
  listLabel,
  loadingStartMsg
};
